import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

export const cccRegistrationStore = defineStore('cccRegistration', {
  state: () => ({
    registrations: [],
    loading: {
      registrations: false,
      deleting: false,
      registering: false
    }
  }),
  actions: {
    async getRegistrations(firm) {
      this.loading.registrations = true
      try {
        const response = await api.get(`diagnostics/registrations/${firm}`)
        this.registrations = response || []
      } catch (error) {
        console.error('Error fetching registrations:', error)
        this.registrations = []
      } finally {
        this.loading.registrations = false
      }
    },
    async deleteRegistration(id) {
      this.loading.deleting = true
      try {
        await api.delete(`diagnostics/registrations/${id}`)
        return { success: true }
      } catch (error) {
        console.error('Error deleting registration:', error)
        return { success: false, error: error.message }
      } finally {
        this.loading.deleting = false
      }
    },
    async testRegisterADAS(data) {
      this.loading.registering = true
      try {
        const response = await api.post('diagnostics/registerADAS', data)
        return { success: true, data: response }
      } catch (error) {
        console.error('Error registering ADAS:', error)
        return { success: false, error: error.message }
      } finally {
        this.loading.registering = false
      }
    },
    async testRegisterMCP(data) {
      this.loading.registering = true
      try {
        const response = await api.post('diagnostics/registerMCP', data)
        return { success: true, data: response }
      } catch (error) {
        console.error('Error registering MCP:', error)
        return { success: false, error: error.message }
      } finally {
        this.loading.registering = false
      }
    }
  }
})
